import { Injectable, EventEmitter } from '@angular/core';
import { SystemEvent } from 'src/app/shared/enums/system-event.enum';
import { Subscription } from 'rxjs';

@Injectable()
export class EventsService {
  private readonly events = new Map<SystemEvent, EventEmitter<any>>();

  public subscribe(type: SystemEvent, next: (value: any) => void): Subscription {
    if (!this.events.has(type)) {
      this.events.set(type, new EventEmitter());
    }

    return this.events.get(type).subscribe(next);
  }

  public emit(type: SystemEvent, value?: any): void {
    const event = this.events.get(type);

    if (!event) {
      return;
    }

    event.emit(value);
  }
}
